"use client";

import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import Image from "next/image";

export default function HeaderBasic({ data }) {
  const { logo, menu = [], cta, layout = {}, background = {} } = data;
  const [open, setOpen] = useState(false);

  const isSticky = layout.sticky;
  const isTransparent = layout.transparent;
  const bgClass =
    background.type === "color"
      ? `bg-[${background.value}]`
      : isTransparent
        ? "bg-transparent"
        : "bg-white";

  return (
    <header
      className={`w-full z-50 ${isSticky ? "sticky top-0" : ""} ${bgClass} shadow-sm`}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link href="/" className="relative h-8 w-auto aspect-[4/1]">
          <Image
            src={logo?.src}
            alt={logo?.alt || "Logo"}
            fill={true}
            sizes="160px"
            priority={true}
            className="h-8 w-auto object-contain object-left"
          />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 items-center">
          {menu.map((item, idx) => (
            <Link
              key={idx}
              href={item.href || "#"}
              className="text-sm font-medium text-gray-700 hover:text-primary"
            >
              {item.icon && <span className="mr-1">{item.icon}</span>}
              {item.label}
            </Link>
          ))}
          {cta && (
            <Link
              href={cta.href}
              className={`ml-4 px-4 py-2 rounded ${
                cta.style === "primary"
                  ? "bg-primary text-white"
                  : cta.style === "secondary"
                    ? "bg-gray-200 text-gray-900"
                    : "text-primary underline"
              }`}
            >
              {cta.text}
            </Link>
          )}
        </nav>

        {/* Mobile Toggle */}
        <button onClick={() => setOpen(!open)} className="md:hidden">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white border-t">
          <div className="flex flex-col px-4 py-2 space-y-2">
            {menu.map((item, idx) => (
              <Link
                key={idx}
                href={item.href}
                className="text-sm font-medium text-gray-700 hover:text-primary"
              >
                {item.icon && <span className="mr-1">{item.icon}</span>}
                {item.label}
              </Link>
            ))}
            {cta && (
              <Link
                href={cta.href}
                className={`mt-2 px-4 py-2 text-center rounded ${
                  cta.style === "primary"
                    ? "bg-primary text-white"
                    : cta.style === "secondary"
                      ? "bg-gray-200 text-gray-900"
                      : "text-primary underline"
                }`}
              >
                {cta.text}
              </Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
